import React from 'react'
import { Link } from 'react-router-dom'
import Faq from './Faq'
import Safe from './Safe'
import WhyChoose from './WhyChoose'

const VirtualKeyboard = () => {
  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
          <li><Link to="/audio/">Home</Link></li>
          <li>Meeting</li>
          <li>Virtual Keyboard</li>
        </ul>
        <div className="banner-content-sec text-center">
          <h1 className="first-head">Virtual Keyboard</h1>
          <h3 className="second-head"></h3>
        </div>
      </div>
      <Safe />
      <WhyChoose />
      <Faq />
    </>
  )
}

export default VirtualKeyboard